export class JntAccountInputModel {
    constructor(payload) {
        if (!payload) {
            // Handle null case
            this.uuid = '';
            this.customerId = '';
            this.validationStatus = '';
            this.dateSubmitted = '';
            return;
        }
        const { uuid, customerId, validationStatus, dateSubmitted } = payload;
        this.uuid = uuid;
        this.customerId = customerId;
        this.validationStatus = validationStatus;
        this.dateSubmitted = dateSubmitted;
    }
}
